import {
  StationDashboardModel,
  StationDashboardSubscriptionModel,
  StationDashboardUpdModel,
} from '@/types/channel/station/station.model';
import {numberCommaString} from '@/utils/channel';
import {ChannelT} from '@/utils/i18n/channel';
import React from 'react';

interface SupportInfoProp {
  fanCount?: StationDashboardUpdModel['fanCount'];
  subscriptionCount?: StationDashboardSubscriptionModel['total'];
  tier1Count?: StationDashboardSubscriptionModel['tier1'];
  tier2Count?: StationDashboardSubscriptionModel['tier2'];
  fanclubCount?: StationDashboardModel['fanclubCount'];
  supporterCount?: StationDashboardModel['supporterCount'];
}
const SupportInfo = ({
  fanCount,
  subscriptionCount,
  tier1Count,
  tier2Count,
  fanclubCount,
  supporterCount,
}: SupportInfoProp) => {
  const SupportInfoData = [
    {label: ChannelT('애청자 수'), value: fanCount},
    {label: ChannelT('구독팬 수'), value: subscriptionCount},
    {label: ChannelT('베이직'), value: tier1Count},
    {label: ChannelT('플러스'), value: tier2Count},
    {label: ChannelT('팬클럽 수'), value: fanclubCount},
    {label: ChannelT('서포터 수'), value: supporterCount},
  ];

  return (
    <>
      <dl>
        <dt>{ChannelT('후원 정보')}</dt>
        {SupportInfoData.map((item, index) => (
          <dd key={index}>
            <strong>{item.label}</strong>
            <b>
              {ChannelT('{{count}}명', {
                placeholder: {
                  count: numberCommaString(item.value ?? 0),
                },
              })}
            </b>
          </dd>
        ))}
      </dl>
    </>
  );
};

export default SupportInfo;
